const $inject = [
  "$rootScope",
  "$scope",
  "$state",
  "$uibModal",
  "ReferralService",
  "data",
];

class ReferralController {
  constructor(
    $rootScope,
    $scope,
    $state,
    $uibModal,
    ReferralService,
    data
  ) {
    this.$rootScope = $rootScope;
    this.$scope = $scope;
    this.$state = $state;
    this.$uibModal = $uibModal;
    this.ReferralService = ReferralService;

    $scope.refund_modal = {
      open: false,
    };
    $scope.max_id = data.max_id;
    $scope.hmr_id = data.max_id;
    $scope.hmr = data.hmr;

    if (data.hmr) {
      $scope.hmr_pharmacists = data.hmr.assignedPharmacist? [data.hmr.assignedPharmacist]: [];

      let status = $rootScope.data.hmr_statuses.find(hmr_status => hmr_status.id === data.hmr.status.id);
      if (status) {
        data.hmr.status = status;
      }

      for (let hmr_status of $rootScope.data.hmr_statuses) {
        if (hmr_status.name === "new") {
          hmr_status.name = "unassigned";
        }

        hmr_status.name = hmr_status.name.replace(/canceled/ig, "cancelled");
        hmr_status.name = hmr_status.name.replace(/invalid_duplicate/ig, "duplicate");
      }

      if (data.hmr.assignedPharmacist) {
        let pharmacist = $rootScope.data.pharmacists.find(pharmacist => pharmacist.id === data.hmr.assignedPharmacist.id);
        if (pharmacist) {
          data.hmr.assignedPharmacist = pharmacist;
        }
      }

      this.original_geolocation = {
        latitude: data.hmr.patientLatitude,
        longitude: data.hmr.patientLongitude,
      };
    }
  }

  view(hmr_id) {
    //noinspection JSCheckFunctionSignatures
    this.$state.go("admin.referrals.referral.view", {hmr_id});
  }

  edit(hmr_id) {
    this.$scope.go_to_edit = true;
    //noinspection JSCheckFunctionSignatures
    this.$state.go("admin.referrals.referral.edit", {hmr_id});
  }

  clear_geolocation() {
    this.$scope.hmr.patientLatitude = "";
    this.$scope.hmr.patientLongitude = "";
  }

  reset_geolocation() {
    this.$scope.hmr.patientLatitude = this.original_geolocation.latitude;
    this.$scope.hmr.patientLongitude = this.original_geolocation.longitude;
  }

  use_clinic_geolocation() {
    this.$scope.hmr.patientLatitude = this.$scope.hmr.clinic.geolocation.latitude;
    this.$scope.hmr.patientLongitude = this.$scope.hmr.clinic.geolocation.longitude;
  }

  look_up_geolocation() {
    let self = this;
    this.$scope.geolocation_lookup = true;

    function handleSuccess(response) {
      self.$scope.hmr.patientLatitude = response.data.data.latitude;
      self.$scope.hmr.patientLongitude = response.data.data.longitude;
      self.$scope.geolocation_lookup = false;
    }

    function handleError(response) {
      self.$scope.geolocation_lookup = false;
    }

    this.ReferralService.look_up_geolocation(this.$scope.hmr, handleSuccess, handleError);
  }

  refund_request() {
    let self = this;
    this.$scope.refund_modal.is_open = true;

    let refund_modal_instance = this.$uibModal.open({
      animation: true,
      backdrop: true,
      templateUrl: "hmrRefundRequestModal.html",
      controller: "HmrRefundRequestModalController",
      controllerAs: "HmrRefundRequestCtrl",
      resolve: {
        type: function () {
          return "admin";
        },
        hmr: self.$scope.hmr,
        refund_reasons: function (AdminService) {
          return AdminService.get_refund_reasons();
        },
      },
    });

    refund_modal_instance.closed.then(function () {
      self.$scope.refund_modal.is_open = false;
    });
  }

  save_referral() {
    let self = this;
    this.$scope.saving = true;

    function handleSuccess(response) {
      self.$scope.saving = false;
      return response.data.data;
    }

    function handleError(response) {
      self.$scope.saving = false;
    }

    this.ReferralService.save_hmr(this.$scope.hmr, handleSuccess, handleError);
  }

  //noinspection JSUnusedGlobalSymbols
  get_pharmacist_tags($query) {
    let self = this;
    //noinspection JSUnusedLocalSymbols
    return new Promise(function (resolve, reject) {
      resolve(self.$rootScope.data.pharmacists.filter(
        pharmacist => pharmacist.name.toLowerCase().includes($query.toLowerCase()) || `${pharmacist.id}`.includes($query.toLowerCase())
      ));
    });
  }

  pharmacist_added($pharmacist) {
    this.$scope.hmr_pharmacists = [$pharmacist];
    this.$scope.hmr.assignedPharmacist = $pharmacist;
  }

  pharmacist_removed($pharmacist) {
    this.$scope.hmr.assignedPharmacist = null;
  }
}

ReferralController.$inject = $inject;
export default ReferralController;



/** WEBPACK FOOTER **
 ** D:/server/Apache24/htdocs/hmr/app/HMRX_App/scripts/src/admin/controllers/referral.controller.js
 **/